import { SingletonComponentStateManager } from 'shared/dialogs/SingletonComponentStateManager';
import { ConfirmParams } from './ConfirmDialog';

export type DialogList = Array<ConfirmParams>

/**
 * Global state variable to keep track of the currently-shown dialogs.
 * This is a global variable instead of Redux because Redux doesn't like it when you
 * try to store non-serializable values (like callback functions) in the state tree.
 */
export const STATE_MANAGER = new SingletonComponentStateManager<DialogList>('ConfirmDialogs', []);
